import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "card" }
const _hoisted_2 = { class: "card-container flex align-items-left justify-content-start" }
const _hoisted_3 = { class: "p-2 mr-3" }
const _hoisted_4 = { class: "p-2 mr-3" }
const _hoisted_5 = { class: "p-2" }
const _hoisted_6 = { class: "p-2" }
const _hoisted_7 = { class: "card-container flex align-items-left justify-content-start" }
const _hoisted_8 = { class: "p-2 mr-3" }
const _hoisted_9 = { class: "card-container flex align-items-left justify-content-start" }
const _hoisted_10 = { class: "p-2 mr-3" }
const _hoisted_11 = { class: "p-2 mr-3" }
const _hoisted_12 = { class: "card-container flex align-items-left justify-content-start" }
const _hoisted_13 = { class: "p-2 mr-3" }


import {Company} from '@/components/blocks/Types'
import Panel from 'primevue/panel'
import BsLabel from "@/components/blocks/BsLabel.vue";

// Define component properties
interface Properties {
  company: Company,
  label: string

}


export default /*#__PURE__*/_defineComponent({
  __name: 'CompanyCard',
  props: {
    company: null,
    label: null
  },
  setup(__props: any) {

const props = __props as {
  company: Company,
  label: string

};




// Define functions
function convertBoolean(value:boolean, t:string, f:string) {
  if (value) return t; else return f
}


return (_ctx: any,_cache: any) => {
  return (__props.company)
    ? (_openBlock(), _createBlock(_unref(Panel), {
        key: 0,
        header: __props.label
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("div", _hoisted_3, [
                _createVNode(BsLabel, {
                  text: __props.company.companyName,
                  label: "Company name"
                }, null, 8, ["text"])
              ]),
              _createElementVNode("div", _hoisted_4, [
                _createVNode(BsLabel, {
                  text: __props.company.ic,
                  label: "IČ"
                }, null, 8, ["text"])
              ]),
              _createElementVNode("div", _hoisted_5, [
                _createVNode(BsLabel, {
                  text: convertBoolean(__props.company?.platceDph, 'Ano', 'Ne'),
                  label: "Vat payer"
                }, null, 8, ["text"])
              ]),
              _createElementVNode("div", _hoisted_6, [
                _createVNode(BsLabel, {
                  text: __props.company.dic,
                  label: "DIČ"
                }, null, 8, ["text"])
              ])
            ]),
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("div", _hoisted_8, [
                _createVNode(BsLabel, {
                  text: __props.company.bankAccountNumber,
                  label: "Bank acount number"
                }, null, 8, ["text"])
              ])
            ]),
            _createElementVNode("div", _hoisted_9, [
              _createElementVNode("div", _hoisted_10, [
                _createVNode(BsLabel, {
                  text: __props.company.email,
                  label: "e-mail"
                }, null, 8, ["text"])
              ]),
              _createElementVNode("div", _hoisted_11, [
                _createVNode(BsLabel, {
                  text: __props.company.phoneNumber,
                  label: "Phone Number"
                }, null, 8, ["text"])
              ])
            ]),
            _createElementVNode("div", _hoisted_12, [
              _createElementVNode("div", _hoisted_13, [
                _createVNode(BsLabel, {
                  text: __props.company.ulice + ' ' + __props.company.cisloDomu + ' / ' + __props.company.obec + ' - ' + __props.company.castObce,
                  label: "Address"
                }, null, 8, ["text"])
              ])
            ])
          ])
        ]),
        _: 1
      }, 8, ["header"]))
    : _createCommentVNode("", true)
}
}

})